// TODO: Need to fix this so the common module isn't dependent on the auth module
import {
  ADD_LOGIN_ERROR,
  CHANGE_USER_ACCOUNT,
  LOGOUT,
} from 'portal-modules/auth/redux/modules/user'
import createRequestSaga from 'portal-modules/common/redux/create-request-saga'
import { leaseAndRentWordReplacer } from 'portal-modules/common/utils/lease-and-rent-word-replacer'
import { select, takeLatest, put } from 'redux-saga/effects'
// action types
export const ADD_ERROR = 'rp/errors/ADD_ERROR'
export const REMOVE_ERROR = 'rp/errors/REMOVE_ERROR'
export const GET_ERROR = 'rp/errors/GET_ERROR'

// reducer
export default function leases(state = {}, { payload, type }) {
  switch (type) {
    case ADD_ERROR:
    case ADD_LOGIN_ERROR:
      return {
        ...state,
        [payload.key]: payload.message,
      }
    case REMOVE_ERROR:
      return Object.keys(state).reduce((obj, key) => {
        if (key === payload) return obj
        return { ...obj, [key]: state[key] }
      }, {})
    case CHANGE_USER_ACCOUNT:
    case LOGOUT:
      return {}
    default:
      return state
  }
}

// action creators
// payload = { key: string, message: string }
export const addError = payload => ({ type: GET_ERROR, payload })

// payload = string
export const removeError = payload => ({ type: REMOVE_ERROR, payload })

function* handleLoginError(action) {

  const { isLeaseAndRentWordReplaced } = yield select(
    ({ productPermissions, propertyAssociation }) => ({
      isLeaseAndRentWordReplaced:
        productPermissions?.replace_lease_and_rent ||
        propertyAssociation?.resident_portal?.replace_lease_and_rent ||
        false,
    }),
  )
 

  if (isLeaseAndRentWordReplaced && action?.payload?.message) {

    const message = action?.payload?.message

    if (typeof message === 'string') {
      action.payload.message = leaseAndRentWordReplacer(message)
    } else if (typeof message === 'object' && message !== null) {
      const updatedMessage = { ...message }
      if (typeof updatedMessage?.message === 'string') {
        updatedMessage.message = leaseAndRentWordReplacer(
          updatedMessage?.message,
        )
      }

      if (Array.isArray(updatedMessage?.fields)) {
        updatedMessage.fields = updatedMessage?.fields?.map(field => ({
          ...field,
          message: field?.message
            ? leaseAndRentWordReplacer(field?.message)
            : field?.message,
        }))
      }

      action.payload.message = updatedMessage
    }
  }

  yield put({ type: ADD_ERROR, payload: action.payload })
}

export function* watchHandleError() {
  yield takeLatest(
    GET_ERROR,
    createRequestSaga(handleLoginError, {
      key: 'loginError',
      onError: '',
      write: true,
    }),
  )
}

export const sagas = [watchHandleError]
